import { CustomerExclusivity } from "~/common/Store/models/ProductListing";
import { User } from "~/common/Store/models/User";

export default (customerExclusivity: CustomerExclusivity, user: User) => {
  if (!customerExclusivity) return false;

  const isNonExclusiveProduct =
    !customerExclusivity.disallowNonMemberToPurchase ||
    (customerExclusivity.allowPlatinumToPurchase && user?.platinum?.enabled) ||
    (customerExclusivity.allowWebstaurantPlusToPurchase && user?.hasWebPlus);

  return isNonExclusiveProduct;
};
